"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDrawingNetLabels = mapDrawingNetLabels;
function mapDrawingNetLabels(drawing, mapNet) {
    let result = drawing;
    if (result.net !== undefined) {
        const mapped = mapNet(String(result.net));
        if (mapped === null) {
            result = { ...result };
            delete result.net;
        }
        else if (mapped !== undefined) {
            result = { ...result, net: mapped };
        }
    }
    if (result.type === 'group') {
        const group = result;
        let childrenChanged = false;
        const children = group.drawings.map((child) => {
            const mappedChild = mapDrawingNetLabels(child, mapNet);
            childrenChanged ||= mappedChild !== child;
            return mappedChild;
        });
        if (childrenChanged) {
            result = { ...result, drawings: children };
        }
    }
    return result;
}
//# sourceMappingURL=mapDrawingNetLabels.js.map